import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "filterBy",
  standalone: false,
})
export class FilterByPipe implements PipeTransform {
  transform(value: string[], args?: string): string[] {
    if (!value) return null;
    if (!args) return value;

    args = args.toLowerCase();

    return value.filter(function (data) {
      return JSON.stringify(data).toLowerCase().includes(args);
    });
  }
}
